import type { BoxProps } from '@chakra-ui/react';
import { Box, VStack } from '@chakra-ui/react';
import type { ReactNode } from 'react';

export interface ChatPanelProps extends BoxProps {
  visible?: boolean;
  children: ReactNode;
}

export function ChatPanel({ children, visible = true, ...props }: ChatPanelProps) {
  return (
    <Box
      className="ChatPanel"
      as="section"
      display="flex"
      flexDirection="column"
      w="full"
      h="full"
      pl="10px"
      pr={2.5}
      py={2.5}
      visibility={visible ? 'visible' : 'hidden'}
      position={visible ? 'static' : 'absolute'}
      left="-100%"
      top="0"
      zIndex="-100"
      {...props}
    >
      <VStack h="full" bg="bg.panel" rounded="lg" align="stretch" gap={0}>
        {children}
      </VStack>
    </Box>
  );
}

export default memo(ChatPanel);
